module.exports = __webpack_public_path__ + "img/jd.a2b12dbc.png";